// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"node_modules_wavesurfer_js_dist_wavesurfer_js":"11273d22c97d3528","src_app_contacts_contacts_module_ts":"a8acfbe832ab5815","src_app_app_worker_ts":"d403916c070d6909"}[chunkId] + ".js";
};